module.exports = __webpack_public_path__ + "img/LT112043081.f34d2a1d.png";